module.exports = __webpack_public_path__ + "img/PH.d4717000.svg";